import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, runInAction } from "mobx";
import { config } from "../config";
import { Agent } from "../services/agent";
import { AppAction } from "./models/app-action";

export class ActionStore {
	@observable actions: AppAction[] = [];
	@observable loading = false;
	@observable permissionActions = new Map();

	@action async loadPermissionActions(permissionId: string){
		let data = await Agent.ProjectPermissions.getProjectPermissionActions(permissionId);
		runInAction(() => {
			if(data){
				this.permissionActions.set(permissionId, data.map(d => d.id));
				data.forEach(d => {
					let act = new AppAction(d);
					let index = _.findIndex(this.actions, {"id": d.id});
					index > -1 ? this.actions[index] = act : this.actions.push(act);
				});
			}
		});
	}

	@action async loadActions(loadActions = true, forceReload = false){
		if(this.actions.length > 0 && !forceReload){
			log.debug("using cache");
			return;
		}

		this.loading = true;
		let data = await Agent.Actions.all();

		runInAction(() => {
			this.actions = data.map((result : any) => new AppAction(result));
			this.loading = false;
		});
	}

	findByAppId(appId: string){
		return _.filter(this.actions.slice(), {"appId": appId});
	}

	findByPermissionId(permissionId: string): AppAction[]{
		if(this.permissionActions.has(permissionId)){
			return _.filter(this.actions.slice(), (act) => {
				return _.findIndex(this.permissionActions.get(permissionId).map(p => { return {"id": p}; }), {"id": act.id}) > -1;
			});
		}
		else{
			return [];
		}
	}
}



// WEBPACK FOOTER //
// ./src/stores/action-store.ts